var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCcuLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "102px",
    height: "38px",
    viewBox: "0 0 102 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.921569%,30.588235%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 19.167969 -0.0546875 C 19.695312 -0.0546875 20.222656 -0.0546875 20.75 -0.0546875 C 24.984375 0.167969 28.828125 1.503906 32.285156 3.957031 C 32.65625 4.273438 32.996094 4.613281 33.300781 4.976562 C 31.175781 7.5 29.027344 10.003906 26.855469 12.496094 C 23.917969 9.445312 20.449219 8.671875 16.453125 10.179688 C 13.175781 12.113281 11.519531 14.996094 11.476562 18.832031 C 11.460938 20.074219 11.667969 21.28125 12.101562 22.449219 C 12.371094 23.070312 12.636719 23.671875 12.890625 24.257812 C 7.5625 21.59375 4.171875 17.371094 2.714844 11.59375 C 2.527344 10.882812 2.453125 10.167969 2.488281 9.445312 C 5.59375 4.460938 10.058594 1.425781 15.886719 0.339844 C 16.992188 0.164062 18.085938 0.03125 19.167969 -0.0546875 Z M 19.167969 -0.0546875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.921569%,30.588235%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 50.039062 0.0546875 C 55.953125 -0.453125 61.191406 1.148438 65.757812 4.863281 C 66.003906 5.089844 66.230469 5.335938 66.4375 5.597656 C 63.273438 7.164062 60.277344 8.972656 57.445312 11.027344 C 54.042969 8.871094 50.667969 8.929688 47.324219 11.195312 C 45.882812 12.339844 44.882812 13.789062 44.328125 15.550781 C 41.085938 18.925781 37.257812 21.414062 32.851562 23.015625 C 31.796875 17.449219 32.832031 12.320312 35.960938 7.632812 C 39.5625 3.109375 44.257812 0.582031 50.039062 0.0546875 Z M 50.039062 0.0546875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.509804%,69.019608%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 101.945312 4.242188 C 101.945312 10.839844 101.945312 17.4375 101.945312 24.03125 C 101.171875 31.609375 97.023438 36.117188 89.503906 37.546875 C 88.324219 37.722656 87.15625 37.855469 86 37.945312 C 85.507812 37.945312 85.019531 37.945312 84.527344 37.945312 C 80.574219 37.886719 76.992188 36.699219 73.785156 34.382812 C 70.746094 31.746094 69.105469 28.410156 68.867188 24.371094 C 68.808594 17.660156 68.792969 10.953125 68.808594 4.242188 C 72.324219 2.949219 75.945312 2.082031 79.667969 1.640625 C 79.613281 9.109375 79.667969 16.570312 79.835938 24.03125 C 80.507812 26.941406 82.335938 28.410156 85.320312 28.445312 C 88.382812 28.414062 90.25 26.90625 90.917969 23.917969 C 91.085938 16.496094 91.140625 9.070312 91.085938 1.640625 C 94.808594 2.082031 98.429688 2.949219 101.945312 4.242188 Z M 101.945312 4.242188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.509804%,69.019608%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 20.636719 37.945312 C 20.109375 37.945312 19.582031 37.945312 19.054688 37.945312 C 14.316406 37.816406 10.058594 36.328125 6.277344 33.476562 C 2.5 30.164062 0.390625 26 -0.0546875 20.980469 C -0.0546875 19.734375 -0.0546875 18.492188 -0.0546875 17.246094 C 0.0820312 16.152344 0.289062 15.0625 0.566406 13.96875 C 2.832031 20.871094 7.375 25.605469 14.191406 28.160156 C 17.527344 29.171875 20.921875 29.398438 24.371094 28.839844 C 25.785156 28.550781 27.179688 28.210938 28.554688 27.820312 C 30.1875 29.980469 31.808594 32.148438 33.414062 34.324219 C 29.460938 36.636719 25.203125 37.84375 20.636719 37.945312 Z M 20.636719 37.945312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 102,
    height: 38
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.509804%,69.019608%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 52.980469 37.945312 C 52.488281 37.945312 52 37.945312 51.507812 37.945312 C 46.710938 37.820312 42.414062 36.292969 38.617188 33.363281 C 36.265625 31.351562 34.605469 28.882812 33.640625 25.957031 C 37.363281 24.644531 40.714844 22.71875 43.707031 20.1875 C 44.894531 26.261719 48.550781 28.878906 54.675781 28.046875 C 56.550781 27.640625 58.132812 26.773438 59.425781 25.445312 C 61.523438 27.988281 63.597656 30.550781 65.644531 33.136719 C 63.214844 35.40625 60.351562 36.839844 57.050781 37.433594 C 55.683594 37.679688 54.328125 37.851562 52.980469 37.945312 Z M 52.980469 37.945312 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcuLogo);
export default __webpack_public_path__ + "static/media/CCU-logo.90e1d64f06cb10a7c2393f3286853bd2.svg";
export { ForwardRef as ReactComponent };